import { ApiParameters } from './api-parameters';
import { ApiPostRequest } from './api-post-request';

export class RegisterPaymethodIdByExternalReferenceRequest extends ApiPostRequest
{
    public constructor(orderId: number, paymentMethodExternalReference: string, webapiBasepath: string)
    {
      // Endpoint parameters are case-sensitive
      const OrderId = orderId;
      const PaymentMethodExternalReference = paymentMethodExternalReference;
      super('order/registerpaymethodIdbyexternalreference', new ApiParameters(), null, { OrderId, PaymentMethodExternalReference }, webapiBasepath);
    }

}
